package org.catharsis.spendtel.feature.legal

fun legalDocument(type: LegalDocumentType): LegalDocument {
    return when (type) {
        LegalDocumentType.PrivacyPolicy -> SpendTelPrivacyPolicy.document()
        LegalDocumentType.TermsAndConditions -> SpendTelTermsOfService.document()
    }
}

fun legalDocumentRoute(type: LegalDocumentType): String {
    return when (type) {
        LegalDocumentType.PrivacyPolicy -> org.catharsis.spendtel.core.navigation.AppRoutes.PrivacyPolicy.name
        LegalDocumentType.TermsAndConditions -> org.catharsis.spendtel.core.navigation.AppRoutes.TermsAndConditions.name
    }
}
